import {base} from '../../../models/base';

export default {
  namespace: 'about',
  state:{},
//  reducers: {
//  }
  reducers: Object.assign(
    base,
    {
      setData(state, {data}){
        console.info('about/[intro, notice, services...]', data);
        return { ...state, ...data};
      },
    }),
};



// WEBPACK FOOTER //
// ./src/pages/about/models/about.js